import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { AlertTriangle, Building } from "lucide-react";
import React from "react";
import { useAssetSummary } from "../hooks";

export const AssetsKpiCards: React.FC = () => {
  const { data: assetSummary } = useAssetSummary();
  const kpiData = [
    {
      title: "Total Assets",
      count: assetSummary?.totalAssets,
      icon: <Building className="h-6 w-6 text-blue-600" />,
      trendSummary: "Active asset inventory",
      tooltip:
        "The total number of distinct assets currently registered in the system.",
    },
    {
      title: "Assets in Poor Condition",
      count: assetSummary?.poorConditionAssets,
      trendSummary: "Condition score < 40",
      icon: <AlertTriangle className="h-6 w-6 text-red-600" />,
      tooltip:
        "The number of assets whose physical condition score is below the 'Poor' threshold. These are high-priority candidates for maintenance or replacement.",
    },
    {
      title: "Assets with Repeated Failures",
      count: assetSummary?.repeatedFailureAssets,
      trendSummary: "3+ failures in last 12 months",
      icon: <AlertTriangle className="h-6 w-6 text-orange-600" />,
      tooltip:
        "The number of assets that have experienced 3 or more failures in the last 12 months. These assets are unreliable and likely drive up maintenance costs.",
    },
    {
      title: "Assets Overdue for Inspection",
      count: assetSummary?.overdueInspectionAssets,
      trendSummary: "Inspection schedule overdue",
      icon: <AlertTriangle className="h-6 w-6 text-red-600" />,
      tooltip:
        "The number of assets with a mandatory inspection schedule that is past its due date. This poses a potential compliance and safety risk.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {kpiData.map((kpi, index) => (
        <QuickStatsCard
          key={index}
          title={kpi.title}
          count={kpi.count}
          trendSummary={kpi.trendSummary}
          icon={kpi.icon}
          tooltip={kpi.tooltip}
        />
      ))}
    </div>
  );
};
